/**
 * 图表懒加载包装: recharts 体积较大, 拆到单独的 chunk,
 * 只有打开仪表盘 / 成本统计时才下载, 普通用户的报价页不受影响。
 * 加载中占位与图表同高, 避免页面跳动。
 */
import { lazy, Suspense, type ComponentProps } from "react";
import type { TrendChart as TrendChartT, ColumnChart as ColumnChartT } from "./charts";

const TrendChartImpl = lazy(() => import("./charts").then((m) => ({ default: m.TrendChart })));
const ColumnChartImpl = lazy(() => import("./charts").then((m) => ({ default: m.ColumnChart })));

function Placeholder({ height }: { height: number }) {
  return (
    <div style={{ height }} className="flex items-center justify-center text-xs text-muted-foreground">
      图表加载中…
    </div>
  );
}

export function LazyTrendChart(props: ComponentProps<typeof TrendChartT>) {
  return (
    <Suspense fallback={<Placeholder height={props.height ?? 240} />}>
      <TrendChartImpl {...props} />
    </Suspense>
  );
}

export function LazyColumnChart(props: ComponentProps<typeof ColumnChartT>) {
  return (
    <Suspense fallback={<Placeholder height={props.height ?? 220} />}>
      <ColumnChartImpl {...props} />
    </Suspense>
  );
}
